import { EMPTY_DETECTION_FILTERS, detectionFilterCount, type DetectionFacets, type DetectionFilterValues } from '../api/securitee'
import './DetectionsFilters.css'

const SEVERITIES = ['low', 'medium', 'high', 'critical'] as const

/**
 * Bara de filtre de pe Securitee > Detections: gravitate (pastile), regula si
 * tehnica MITRE (din facetele server), interval de timp. Spre deosebire de fila
 * XDR a tichetului (client-side pe cel mult 200 de randuri), aici lista e
 * server-side, deci filtrele pleaca drept parametri la `detections-table`; cautarea
 * libera ramane la casuta DataTables. Gravitatea e multi, regula/MITRE una singura,
 * ca in fila XDR.
 */
export function DetectionsFilters({
  filters,
  facets,
  onChange,
}: {
  filters: DetectionFilterValues
  facets: DetectionFacets
  onChange(next: DetectionFilterValues): void
}) {
  const active = detectionFilterCount(filters)
  const toggleSeverity = (sev: string) =>
    onChange({
      ...filters,
      severities: filters.severities.includes(sev) ? filters.severities.filter((s) => s !== sev) : [...filters.severities, sev],
    })

  return (
    <div className="det-filters" role="group" aria-label="Filter detections">
      <div className="det-sev btn-group btn-group-sm" role="group" aria-label="Severity">
        {SEVERITIES.map((sev) => {
          const on = filters.severities.includes(sev)

          return (
            <button key={sev} type="button" className={`btn btn-default det-sev-pill det-sev-${sev}${on ? ' active' : ''}`} aria-pressed={on} onClick={() => toggleSeverity(sev)}>
              {sev}
            </button>
          )
        })}
      </div>

      <select
        className="form-control input-sm det-filter-rule"
        aria-label="Rule"
        value={filters.rules[0] ?? ''}
        onChange={(e) => onChange({ ...filters, rules: e.target.value === '' ? [] : [e.target.value] })}
      >
        <option value="">All rules</option>
        {facets.rules.map((r) => (
          <option key={r} value={r}>
            {r}
          </option>
        ))}
      </select>

      <select
        className="form-control input-sm det-filter-mitre"
        aria-label="MITRE technique"
        value={filters.mitre[0] ?? ''}
        onChange={(e) => onChange({ ...filters, mitre: e.target.value === '' ? [] : [e.target.value] })}
      >
        <option value="">All MITRE</option>
        {facets.mitre.map((m) => (
          <option key={m} value={m}>
            {m}
          </option>
        ))}
      </select>

      <label className="det-filter-time">
        From <input type="datetime-local" className="form-control input-sm" aria-label="From time" value={filters.from} onChange={(e) => onChange({ ...filters, from: e.target.value })} />
      </label>
      <label className="det-filter-time">
        To <input type="datetime-local" className="form-control input-sm" aria-label="To time" value={filters.to} onChange={(e) => onChange({ ...filters, to: e.target.value })} />
      </label>

      {active > 0 && (
        <button type="button" className="btn btn-xs btn-link det-filter-clear" onClick={() => onChange(EMPTY_DETECTION_FILTERS)}>
          Clear filters ({active})
        </button>
      )}
    </div>
  )
}
